<template>
  <div :class="`news-item ${expand ? 'news-item-resize' : ''}`" :id="this.slug">
    <div class="news-item-image" :style="`background-image: url(${image})`" v-if="image" />
    <div class="news-item-content">
      <div class="news-item-title">{{ title }}</div>
      <div class="news-item-text" v-html="fullText" />
      <div class="news-item-resize-btn" @click="toggleShowFull">
        <span v-if="!expand">Показать всю новость</span><span v-else>Скрыть</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { boolean } from 'yup'
import { useRoute, useRouter } from 'vue-router'
export default {
  name: 'NewsItem',
  props: {
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    fullText: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const route = useRoute()

    const { t, n } = useI18n()
    const showFull = ref(route.hash === `#${props.slug}`)
    return { t, n, showFull }
  },
  computed: {
    expand() {
      return this.showFull
    },
  },
  methods: {
    toggleShowFull() {
      this.showFull = !this.showFull
    },
  },
}
</script>
